import React from 'react';
import { Container } from '../components.js';
import StringUtils from '../../utils/stringutils.js';

class WhatOthers  extends React.Component {

  constructor(props) {
    super(props);

    this.getData = this.getData.bind(this);
    this.incrementPage = this.incrementPage.bind(this);
    this.decrementPage = this.decrementPage.bind(this);

    this.state = { response : {data :{}, dataError: false}, page: 0};
  }

  componentDidMount() {
    let isError = (this.state.response.dataError !== false && typeof this.state.response.dataError !== 'undefined');
    console.log("Mounted");
    if(this.state.response.data !== null && Object.keys(this.state.response.data).length === 0 && !isError) {
      this.getData();
    }

  }

  componentDidUpdate() {
    let isError = (this.state.response.dataError !== false && typeof this.state.response.dataError !== 'undefined');
    console.log("Updated");
    if(this.state.response.data !== null && Object.keys(this.state.response.data).length === 0 && !isError) {
      this.getData();
    }

  }

  incrementPage() {
    let curPage = this.state.page;
    var nextPage = parseInt(curPage) + 1;

    this.setState({
      response: {
        data: {},
        dataError: false
      },
      page: nextPage
    });

  }

  decrementPage() {
    var curPage = this.state.page;
    if(curPage <= 0) curPage = 1; //Make sure we don't go below 0 but if they are pressing this maybe we need to reload?

    var nextPage = curPage - 1;

    this.setState({
      response: {
        data: {},
        dataError: false
      },
      page: nextPage
    });

  }

  getData() {
    console.log('getting data');
    var component = this;

    var callback = function(response) {
      console.log(response);
      if(response.code === 200) {
        if(response.detail !== "Report generated") {
            component.setState({response: { data : {}, dataError : response.detail}});
        }
        else {
          component.setState({response: { data : response.data, dataError : false}, page: parseInt(response.data.page)});
        }
      }
      else {
        component.setState({response: { data : {}, dataError : response.detail}});
      }
    };
    
    console.log("Page: " + this.state.page);
    window._fiSponsor.getWhatOthers(callback, this.state.page, this.props.pagesize);
  }

  render() {
    const iconAndDataSize = {
      width: '80%',
      height: '20%'
    };

    const containerSize = this.props.size;

    let isError = (this.state.response.dataError !== false && typeof this.state.response.dataError !== 'undefined');
    var containerContent = [];

    var first = true;
    for(var key in this.state.response.data.goals) {
      var data = this.state.response.data.goals[key];
      var addClass = (first) ? ' first' : '';
      var content = (<OthersGoal addClass={addClass} key={key + "-" + this.props.type} size={iconAndDataSize} icon={data.icon} amount={data.amount} label={data.label} duration={data.duration} />);
      containerContent.push(content);
      if(first) first = false;
    }

    if(containerContent.length === 0 && !isError) {
      containerContent = 'Loading...';
    }
    else if(isError) {
      console.log(this.state.response.dataError);
      containerContent = 'Unable to retrieve What Users Are Saving For. Contact support@plinqit.com if this persists.';
    }
    else {
      console.log("Container Content Length: " + containerContent.length);
      console.log("Pagesize: " + this.props.pagesize);
      if(containerContent.length === this.props.pagesize && this.state.response.data && parseInt(this.state.response.data.current) < parseInt(this.state.response.data.total)) {
        console.log("Adding next btn");
        var nextBtn = (<NextButton key={"Next Button"} click={this.incrementPage} />);
        containerContent.push(nextBtn);
      }
      if(this.state.page > 0) {
        console.log("Adding prev button");
        var prevBtn = (<PreviousButton key={"Prev Button"} click={this.decrementPage} />);
        containerContent.unshift(prevBtn)
      }



      containerContent = (<div className="App-ChartsBoxCol1 space-between">{containerContent}</div>);
    }

    return (
        <Container key={this.props.type + "Goals"} moreClass={'MinPad relative ' + this.props.addClass} 
        moreTitleClass={"App-ChartsTitle"} titles={[{'label' : this.props.title, 'onClick' : ''}]} 
        contents={containerContent} size={containerSize} onclick={this.props.onclick} bgcolor="rgb(100, 160, 67)" />
    );
  }
}

function OthersGoal (props) {

  return (
    <div className={'goal-and-data ' + props.addClass}>
      <img src={props.icon} alt="Goal Icon" />
      <div className='green big-goal-text'>{StringUtils.dollar_format(props.amount, true)} </div>
      <div className='small-goal-text'>&nbsp;for {props.label} over&nbsp;</div>
      <div className='orange big-goal-text'>{props.duration} months</div>
    </div>
  );
}

function PreviousButton (props) {
  return (
    <div className='previousButton others-btn' onClick={props.click}>
      <img src={process.env.PUBLIC_URL + 'images/grey-arrow-up.png'} alt="Up Arrow" />
      <div className='small-value-text'>See Previous</div>
    </div>
  );
}

function NextButton (props) {
  return (
    <div className='nextButton others-btn' onClick={props.click}>
      <img src={process.env.PUBLIC_URL + 'images/grey-arrow@2x.png'} alt="Down Arrow" />
      <div className='small-value-text'>See More</div>
    </div>
  );
}

export {WhatOthers, OthersGoal};








